<template>
  <el-select
    v-model="computedValue"
    :popper-class="popperClass"
    :placeholder="placeholder"
    v-bind="$attrs"
    class="BrandsPicker"
    filterable
    @change="(v) => $emit('change',v)"
  >
    <el-option
      v-for="item in brands"
      :key="item.code"
      :label="item.name"
      :value="$attrs['value-key'] ? item : item.id"
    >
      <slot :brand="item" />
    </el-option>
  </el-select>
</template>

<script>
import BasicSelect from '@/shared/js/components/core/BasicSelect.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BrandsPicker',
  extends: BasicSelect,
  props: {
    popperClass: {
      type: String,
      default: 'brandsPickerModal'
    },
    placeholder: {
      type: String,
      default () { return this.$t('components.brands_picker.placeholder') }
    }
  },
  computed: {
    ...mapGetters(['brands'])
  }
}
</script>
